import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

const useEventParameters = (options?: Toolkit.GoogleAnalytics.Options): TrackEventBaseParameters => ({
    page_type: ga.use.pageType(options),
});

export default useEventParameters;
